import axios from 'axios'
import { User } from 'firebase/auth'

import { ExclusionForm } from './types'

export const postNewExclusion = async (userAuth: User, exclusionForm: ExclusionForm[]) => {
	try {
		await axios.post<{ message: string; quantity: number }>(
			`${process.env.REACT_APP_API_URL}/exclusion-list`,
			exclusionForm,
			{
				headers: {
					Authorization: await userAuth.getIdToken(),
				},
			}
		)
		return true
	} catch (error: any) {
		console.error('❌ Error adding new exclusion:', error.message)
		throw error
	}
}
